<template>
    <div class="form-table__td" :style="styleObject" :tabindex="tabindex"
    >
        <slot>{{ text }}</slot>
    </div>
</template>

<script>
    export default {
        name: "TableTd",
        props: {
            text: {
                type: String,
                default: "No Text",
            },
            justifyContent: {
                type: String,
                default: "center",
            },
            alignItems: {
                type: String,
                default: "center",
            },
            tabindex: {
                type: Number,
                default: undefined, // Default 로는 focus 가능한 요소가 아님
            },
        },
        computed: {
            styleObject() {
                return {
                    justifyContent: this.justifyContent,
                    alignItems: this.alignItems,
                    backgroundColor: this.backgroundColor,
                }
            }
        }
    }
</script>

<style scoped>
    .form-table__td {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 1rem 1.5rem;
        overflow: hidden;
    }
</style>